/**
 * Clears any current text selection in the global `window` object.
 *
 * This function checks if there's an active text selection in the window and removes all selection ranges if present.
 * It's useful in scenarios where you want to programmatically deselect text, such as after copying content to the clipboard
 * or when updating the UI where a text selection might interfere with user experience.
 *
 * @example
 * // After copying text, clear the selection
 * copyTextToClipboard();
 * clearGlobalSelection();
 */
export const clearGlobalSelection = (): void => {
  const selection = window?.getSelection();
  if (selection) {
    selection?.removeAllRanges();
  }
};
